import { PlaceholdersId, TFComponent } from '@types';
import { LogoPlaceholder } from './logo';

export const logo: TFComponent = {
	component: LogoPlaceholder,
	id: PlaceholdersId.logo,
	name: 'logo',
};
